import { render, staticRenderFns } from "./SystemSettingLayout.vue?vue&type=template&id=3ddbb692&scoped=true"
import script from "./SystemSettingLayout.vue?vue&type=script&lang=js"
export * from "./SystemSettingLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddbb692",
  null
  
)

export default component.exports